export function getLangsUrlByAppRoutes(appRoutes) {
  return Object.keys(appRoutes).map(key => appRoutes[key].LANG_URL)
}
